import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import Controls from '../../../controls/Controls';
import { Form } from '../../../controls/useForm';
import { Multiselect } from 'multiselect-react-dropdown';
import { request } from '../../../../api/Service';
import { getErrorMessage } from '../../../utils/errorHandler';
import { store } from '../../../../redux-store/store';
import { toast } from 'react-toastify';

export function UserLocationForm(props) {
  const { utilityReducer } = store.getState();
  const [userLocations, setUserLocations] = useState([]);
  const [usernewLocation, setnewUserLocation] = useState({});
  const [button, setButonLoader] = useState(false);
  const [companyLocations, setCompanyLocations] = useState([]);
  const { userId, companyId, recordForEdit } = props;

  function onSelect(e) {
    setnewUserLocation(e);
  }

  function onRemove(e) {
    setnewUserLocation(e);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    var data = {
      userId: recordForEdit.id,
      locations: usernewLocation,
    };
    setButonLoader(true);
    request('post', data, `api/Admin/user-location`)
      .then((data) => {
        if (data == 'This user cannot be assigned to two locations') {
          alert(data);
          setButonLoader(true);
        } else {
          alert('Success');
          setButonLoader(true);
          props.setOpenPopup(false);
        }
        setButonLoader(true);
      })
      .catch((data) => {
        const errorMessage = getErrorMessage(e.response);
        // toast.error(errorMessage);
        alert(errorMessage);
      });
  };

  useEffect(() => {
    request(
      'get',
      {},
      `api/Admin/user-locations-multi-select/${
        recordForEdit.id
      }/${store.getState().persistReducer.companyId}`
    ).then((data) => {
      setUserLocations(data.userLocations);
      setCompanyLocations(data.companyLocations);
      setnewUserLocation(data.userLocations);
    });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Multiselect
            options={companyLocations} // Options to display in the dropdown
            selectedValues={userLocations} // Preselected value to persist in dropdown
            onSelect={onSelect} // Function will trigger on select event
            onRemove={onRemove} // Function will trigger on remove event
            displayValue="name" // Property name to display in the dropdown options
          />
        </Grid>
      </Grid>
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <button
          type="submit"
          style={{ background: '#333996' }}
          className="save-button"
        >
          Save & Continue{' '}
          <i className={button === true ? 'fa fa-spinner fa-spin' : ''}></i>
        </button>
      </div>
    </Form>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    companyId: state.persistReducer.companyId,
    companyLocations: state.userReducer.companyLocations,
    userLocations: state.usersReducer.userLocations,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadUserLocation(payload) {
    dispatch({ type: 'LOAD_USER_LOCATIONS', payload });
  },
  AddUser(payload) {
    dispatch({ type: 'ADD_USER', payload });
  },
});

export default UserLocationForm;
